export const project1 = require('./project1.png');
export const project2 = require('./project2.png');
export const project3 = require('./project3.png');
export const project4 = require('./project4.png');
export const project5 = require('./project5.png');
export const project6 = require('./project6.png');
export const project7 = require('./project7.png');
export const project8 = require('./project-min.png');
